class SmgTheme {
  constructor() {
    this.bindMenu();
    this.bindProductVariants();
  }

  bindMenu() {
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      const menuId = button.getAttribute('aria-controls');
      const menu = document.getElementById(menuId);
      if (!menu) return;

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        menu.hidden = expanded;
        const openIcon = button.querySelector('[data-menu-open]');
        const closeIcon = button.querySelector('[data-menu-close]');
        if (openIcon) openIcon.hidden = !expanded;
        if (closeIcon) closeIcon.hidden = expanded;
      });
    });
  }

  bindProductVariants() {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const select = section.querySelector('[data-variant-select]');
      const price = section.querySelector('[data-product-price]');
      const button = section.querySelector('[data-add-to-cart]');
      const label = section.querySelector('[data-add-label]');
      if (!select || !price || !button || !label) return;

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        const comparePrice = option.dataset.comparePrice;
        price.innerHTML = `<span>${option.dataset.price}</span>${comparePrice && comparePrice !== option.dataset.price ? `<s>${comparePrice}</s>` : ''}`;
        button.disabled = !available;
        label.textContent = available ? 'Add to cart' : 'Sold out';
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new SmgTheme());
